import { ToneDot } from "@/components/ui/badge";
import { statusInfo } from "@/lib/appointments";

/** A status in words with its colour beside it (ACL-525): what the status pickers list. */
export function AppointmentStatusLabel({ status }: { status: string }) {
  const { label, tone } = statusInfo(status);
  return (
    <span className="inline-flex items-center gap-1.5">
      <ToneDot tone={tone} />
      {label}
    </span>
  );
}
